// extracted by mini-css-extract-plugin
module.exports = {"desktopPopper":"GiphyDesktop__desktopPopper__2-FYd","desktopPopperTheatre":"GiphyDesktop__desktopPopperTheatre__ipfU4"};